import { formatQueryString } from '@/shared/util/mercury';

export const MESSAGE_AUTHOR_SYSTEM_ID = -1337;

export const USER_PAGE_SIZE = 50;

export enum CONVERSATION_TYPE {
  ACCOUNT = 'account',
  GROUP = 'group',
  INDIVIDUAL = 'individual',
}

export enum STREAM_CHANNEL_TYPES {
  BROADCAST = 'broadcast',
  DIRECT_MESSAGE = 'direct_message',
  CHAT = 'chat',
}

export enum WORKCHAT_VIEWS {
  VIEW_CONVERSATION_LIST = 'VIEW_CONVERSATION_LIST',
  VIEW_CONVERSATION = 'VIEW_CONVERSATION',
  VIEW_CREATE_NEW_CONVERSATION = 'VIEW_CREATE_NEW_CONVERSATION',
  VIEW_NEW_MESSAGE = 'VIEW_NEW_MESSAGE',
  VIEW_NEW_CHANNEL = 'VIEW_NEW_CHANNEL',
  VIEW_CONVERSATION_DETAIL = 'VIEW_CONVERSATION_DETAIL',
  VIEW_ADD_PARTICIPANTS = 'VIEW_ADD_PARTICIPANTS',
}

export const EMOJI: InputType = 'emoji';
export const GIF: InputType = 'gif';
export type InputType = 'emoji' | 'gif';
export type Emoji = {
  emoji: string;
  native: string;
  unified: string;
};

/**
 * Mercury Event Base Payload
 * https://catalog.wiwdata.com/#/entry/entries-0a7cf07a-cb84-41bf-860f-193213b8d3a8
 */
export const WORKCHAT_ONINTERACTION = {
  hostName: window.location.host,
  path: window.location.pathname,
  queryParams: formatQueryString(window.location.search),
  hash: window.location.hash,
  annotations: null,
};

export enum WORKCHAT_ONINTERACTION_ACTIONS {
  messageMenuDeleteClick = 'messageMenuDeleteClick',
  messageDeleteSuccess = 'messageDeleteSuccess',
  messageMenuCopyClick = 'messageMenuCopyClick',
  messageMenuAddReactionClick = 'messageMenuAddReactionClick',
  messageAddReactionClick = 'messageAddReactionClick',
  messageReactionChipClick = 'messageReactionChipClick',
  messageInputAddPhotoClick = 'messageInputAddPhotoClick',
  messageInputShowEmojiPickerClick = 'messageInputShowEmojiPickerClick',
}

export enum WORKCHAT_ERRORS {
  failedToAuthenticate = 'failedToAuthenticate',
  failedToInitClient = 'failedToInitClient',
  failedToPreloadConversations = 'failedToPreloadConversations',
  failedToViewConversation = 'failedToViewConversation',
  failedToQueryStreamUsers = 'failedToQueryStreamUsers',
}
